import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  screenWrapper: {
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    flex: 1,
  },
  headerContainer: {
    paddingLeft: 0,
    paddingHorizontal: 0,
    paddingRight: indent,
    paddingTop: indent,
    paddingBottom: indent,
    minHeight: 0,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    width: '100%' as const,
    alignItems: 'flex-start' as const,
  },
  base: {
    flex: 1,
    backgroundColor: cloudLightest,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
  header: {
    paddingVertical: 20,
    backgroundColor: white,
  },
  heading: {
    marginBottom: 10,
  },
  content: {
    paddingBottom: 20,
  },
  loading: {
    justifyContent: 'center',
    height: 100,
  },
});
